import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Redux action
import { loginUser } from "../../../slices/auth/login/thunk";

// Images 
import logosm from "assets/images/logo-sm.png";
const LoginCover = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [username, setusername] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const bodyElement = document.body;
    bodyElement.classList.add(
      "flex", "items-center", "justify-center", "min-h-screen", "py-16",
      "bg-cover",
      "dark:text-zink-100", "font-public"
    );
    return () => {
      bodyElement.classList.remove(
        "flex", "items-center", "justify-center", "min-h-screen", "py-16",
        "bg-cover", "bg-[#FDE29E]/50",
        "dark:text-zink-100", "font-public"
      );
    };
  }, []);

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  if (!username || !password) {
    setError("Please enter both username and password.");
    return;
  }

  setError(null);

  try {
    await dispatch<any>(loginUser({ username, password }, navigate));
  } catch (err: any) {
    setError(err.message || "Invalid credentials");
  }
};


  return (
    <div className="mb-0 border-none lg:w-[500px] card bg-[#FDE29E]/20  shadow-none dark:bg-zink-500/70">
      <div className="!px-10 !py-12 card-body">
        <a href="/">
          <img src={logosm} alt="" className="hidden h-[10vh] mx-auto dark:block" />
          <img src={logosm} alt="" className="block h-[10vh] mx-auto dark:hidden" />
        </a>

        <div className="mt-8 text-center">
          <p className="text-slate-500 dark:text-zink-200">Login to Admin Panel</p>
        </div>

        <form className="mt-10" onSubmit={handleSubmit}>
          {error && (
            <div className="mb-4 text-sm text-red-500">{error}</div>
          )}

          <div className="mb-3">
            <label htmlFor="username" className="inline-block mb-2 text-base font-medium">UserName / username ID</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setusername(e.target.value)}
              className="form-input dark:bg-zink-600/50 border-slate-200 dark:border-zink-500 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Enter username or username"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="inline-block mb-2 text-base font-medium">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input dark:bg-zink-600/50 border-slate-200 dark:border-zink-500 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Enter password"
            />
          </div>

          <div className="mt-10">
            <button
              type="submit"
              className="w-full text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600"
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginCover;
